import { categories } from '@/mocks/videos';
import CategoryCard from '@/components/feature/CategoryCard';

export default function CategoriesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            热门内容分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            八大分类，总有一个你喜欢的
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <CategoryCard
              key={cat.slug}
              slug={cat.slug}
              name={cat.name}
              icon={cat.icon}
              description={cat.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
}